import React from "react";
import "../styles/Hero.css";
import HeroSinusoidalWaves from "./HeroSinusoidalWaves";

export default function Hero() {
  return (
    <section id="home" className="hero">
      <HeroSinusoidalWaves />
      <div className="hero-content">
        <span className="hero-badge anim-enter anim-delay-1">Confideo Cloud & Code</span>
        <h1 className="anim-enter anim-delay-2">Cloud Devops & AI - One learning Path</h1>
        <p className="anim-enter anim-delay-3">
          Industry-ready training with hands-on projects, expert-led sessions, and career-focused cloud engineering paths.
        </p>
        <button
          type="button"
          className="btn-primary anim-enter anim-delay-4 btn-press"
          onClick={() =>
            document.getElementById("courses")?.scrollIntoView({ behavior: "smooth" })
          }
        >
          Explore Courses
        </button>
        <p className="hero-tagline anim-enter anim-delay-5">Learn. Build. Deploy. Grow.</p>
      </div>
    </section>
  );
}
